const tryRequire = require('try-require')
const fs = require('fs-extra')
const path = require('path')

module.exports = function (state, opts, config) {
    return new Promise((resolve, reject) => {
        resolve()
        // fs.move(
        //     path.resolve(state.OUTPUT_PATH, 'client/main/'),
        //     path.resolve(state.OUTPUT_PATH, 'client/'),
        //     err => {
        //         if (err) {
        //             reject(err)
        //         } else {
        //             resolve()
        //         }
        //     }
        // )
    })
}



// WEBPACK FOOTER //
// ./src/technologies/move-main.js